import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { LoginService } from './_service/login.service';
import { LovComponent } from '../lov/lov.component';
import { FormControl } from '@angular/forms/src/model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginform: FormGroup;
  model: any = {};
  errorMessage: string;
  @ViewChild('lovUnit') lovUnit;
  @ViewChild('lovModal') lovModal;
  lovPost: any[] = [];
  id: string; qid: string; wherecols: string; lovname: string;
  _UnitName: string; _ErpUnitCode: string; _ErpParentUnit: string; _Password: string;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private loginservice: LoginService, public dialog: MatDialog ) {
  }

  ngOnInit() {
    this.loginform = this.formBuilder.group({
      _UsrId: ['', [Validators.required]],
      _Password: ['', [Validators.required]],
      _UnitName: [''],
      _ErpUnitCode: [''],
      _ErpParentUnit:['']
    });
  }

  //------- Lov Call ----///
  openDialog(): void {
    debugger;
    this.id = this.lovUnit.nativeElement.attributes.id.value;
    this.qid = this.lovUnit.nativeElement.attributes.queryid.value;
    this.wherecols = this.loginform.value._UsrId + ';';
    this.lovname = this.lovUnit.nativeElement.attributes.lovname.value;

    this.lovPost.push(this.id, this.qid, this.wherecols, this.lovname);

    const dialogRef = this.dialog.open(LovComponent, {
      width: '800px',
      data: this.lovPost,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      debugger;
      this._UnitName = result.OU_NAME;
      this._ErpUnitCode = result.ERP_UNIT_CODE;
      this._ErpParentUnit = result.ERP_PARENT_UNIT;

      this.lovPost = [];
    });
  }

  ValidateCheck()
  {
    debugger;
    this._Password = btoa(this.loginform.value._Password);
   this.loginform.value._Password = btoa(this.loginform.value._Password);
    this.model = this.loginform.value;
     btoa(this.loginform.value._Password);

    this.loginservice.LoginUser(this.model)
      .subscribe(
      data => {
        debugger;
       if (data.length == 0)
        {

          this.loginform.value._Password = null;
          this.errorMessage = "Invalid UserId and Password";
          this.loginform.reset();

        }
        else
       {
         if (data[0].errormessage == "N") {
           this.errorMessage = 'Password Verified for Shri ' + data[0]._PartyName + '.';

         }
         else {

           this.errorMessage = data[0].errormessage;
         }
        }

        }
      );
  }

  loginSubmit()
  {
    debugger;

    
      this.model = this.loginform.value;
      this.model._ErpUnitCode = this._ErpUnitCode;
      this.model._UnitName = this._UnitName;
      this.model._ErpParentUnit = this._ErpParentUnit;
      this.loginservice.LoginUser(this.model)
        .subscribe(
        data => {
          debugger;
            if (data[0].token == null && data.length == 1) {
              this.loginform.value._Password = null;
              this.errorMessage = "Invalid UserId and Password";
              this.loginform.reset();
            }
            else {

              if (this.model._UnitName == undefined) {
                this.errorMessage = "Please Select Cost Center";
              }
              else
              {

                localStorage.setItem('UnitName', this._UnitName)
                localStorage.setItem('IffcoUnitCodeS', this._ErpUnitCode)
                this.router.navigate(['/Mktg/Dashboard']);
              }


            }
          }
        );
    
   
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

}
$(document).keydown(function (event) {
  if (event.keyCode == 123) { // Prevent F12
    return false;
  } else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) { // Prevent Ctrl+Shift+I
    return false;
  }
});

   
/* To Disable Inspect Element */
$(document).bind("contextmenu", function (e) {
  e.preventDefault();
});

$(document).keydown(function (e) {
  if (e.which === 123) {
    return false;
  }
});
